var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServe3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 0V67H61.7143V41.2308H51.4286V67H0V15.4615L30.8571 0H36V15.4615L66.8571 0H72ZM41.1429 30.9231H30.8571V51.5385H41.1429V30.9231ZM20.5714 30.9231H10.2857V51.5385H20.5714V30.9231Z",
    fill: "#5B21FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServe3);
export default __webpack_public_path__ + "static/media/serve3.de95e20076ffe14e0d20de1b0c45b311.svg";
export { ForwardRef as ReactComponent };